import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { GiftOutlineIcon, InstallmentOutlineIcon, Link, PercentOutlineIcon, Text, TradeInIcon } from '@beef/ui-kit';
import { PromoItem } from "../PromoItem";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var getCreditOption = function getCreditOption(credit) {
  var current = credit !== null && credit !== void 0 ? credit : '';
  var _current$split = current.split('от'),
    _current$split2 = _slicedToArray(_current$split, 2),
    promoLink = _current$split2[0],
    promoText = _current$split2[1];
  if (promoText) {
    return {
      promoCreditLink: promoLink,
      promoCreditText: "\u043E\u0442 ".concat(promoText)
    };
  }
  return {
    promoCreditLink: promoLink
  };
};
export var PromoSection = function PromoSection(_ref) {
  var _device$promoCredit, _device$promoCredit$l, _device$promoTradeIn, _device$promoTradeIn$, _device$promoBundle, _device$promoBundle$l, _device$promoCode, _device$promoCode$lin, _device$promoCredit3, _device$promoCredit4, _device$promoTradeIn2, _device$promoTradeIn3, _device$promoTradeIn4, _device$promoTradeIn5, _device$promoBundle2, _device$promoBundle3, _device$promoBundle4, _device$promoCode2, _device$promoCode3, _device$promoCode4;
  var device = _ref.device,
    size = _ref.size,
    children = _ref.children;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    promoCreditData = _useState2[0],
    setPromoCreditData = _useState2[1];
  var isPromoCredit = !!(device !== null && device !== void 0 && (_device$promoCredit = device.promoCredit) !== null && _device$promoCredit !== void 0 && (_device$promoCredit$l = _device$promoCredit.link) !== null && _device$promoCredit$l !== void 0 && _device$promoCredit$l.length);
  var isPromoTradeIn = !!(device !== null && device !== void 0 && (_device$promoTradeIn = device.promoTradeIn) !== null && _device$promoTradeIn !== void 0 && (_device$promoTradeIn$ = _device$promoTradeIn.link) !== null && _device$promoTradeIn$ !== void 0 && _device$promoTradeIn$.length);
  var isPromoBundle = !!(device !== null && device !== void 0 && (_device$promoBundle = device.promoBundle) !== null && _device$promoBundle !== void 0 && (_device$promoBundle$l = _device$promoBundle.link) !== null && _device$promoBundle$l !== void 0 && _device$promoBundle$l.length) && !device.isNewBundle;
  var isPromoCode = !!(device !== null && device !== void 0 && (_device$promoCode = device.promoCode) !== null && _device$promoCode !== void 0 && (_device$promoCode$lin = _device$promoCode.link) !== null && _device$promoCode$lin !== void 0 && _device$promoCode$lin.length);

  // FIXME What is it? It seems wrong
  // необходимо для SSR
  useEffect(function () {
    var _device$promoCredit2;
    var _getCreditOption = getCreditOption(device === null || device === void 0 ? void 0 : (_device$promoCredit2 = device.promoCredit) === null || _device$promoCredit2 === void 0 ? void 0 : _device$promoCredit2.label),
      promoCreditLink = _getCreditOption.promoCreditLink,
      promoCreditText = _getCreditOption.promoCreditText;
    setPromoCreditData({
      promoCreditLink: promoCreditLink,
      promoCreditText: promoCreditText
    });
  }, [device]);
  var isPromo = isPromoCredit || isPromoBundle || isPromoTradeIn;
  return children || isPromo ? /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', size && "wrapper--".concat(size))
  }, children, isPromoCredit && /*#__PURE__*/React.createElement(PromoItem, {
    icon: /*#__PURE__*/React.createElement(InstallmentOutlineIcon, {
      size: 20
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: ((_device$promoCredit3 = device.promoCredit) === null || _device$promoCredit3 === void 0 ? void 0 : _device$promoCredit3.link) || '',
    isNoUnderline: true,
    onClick: (_device$promoCredit4 = device.promoCredit) === null || _device$promoCredit4 === void 0 ? void 0 : _device$promoCredit4.onClick,
    size: "size5-m",
    variant: "dark"
  }, promoCreditData.promoCreditLink), ' ', /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size5-r-s",
    tagType: "span"
  }, promoCreditData === null || promoCreditData === void 0 ? void 0 : promoCreditData.promoCreditText)), isPromoTradeIn && /*#__PURE__*/React.createElement(PromoItem, {
    icon: /*#__PURE__*/React.createElement(TradeInIcon, {
      size: 20
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: ((_device$promoTradeIn2 = device.promoTradeIn) === null || _device$promoTradeIn2 === void 0 ? void 0 : _device$promoTradeIn2.link) || '',
    isNoUnderline: true,
    onClick: (_device$promoTradeIn3 = device.promoTradeIn) === null || _device$promoTradeIn3 === void 0 ? void 0 : _device$promoTradeIn3.onClick,
    size: "size5-m",
    variant: "dark"
  }, ((_device$promoTradeIn4 = device.promoTradeIn) === null || _device$promoTradeIn4 === void 0 ? void 0 : _device$promoTradeIn4.label) || ''), ' ', /*#__PURE__*/React.createElement(Text, {
    color: "grey50",
    size: "size5-r-s",
    tagType: "span"
  }, device === null || device === void 0 ? void 0 : (_device$promoTradeIn5 = device.promoTradeIn) === null || _device$promoTradeIn5 === void 0 ? void 0 : _device$promoTradeIn5.text)), isPromoBundle && /*#__PURE__*/React.createElement(PromoItem, null, /*#__PURE__*/React.createElement(Link, {
    href: ((_device$promoBundle2 = device.promoBundle) === null || _device$promoBundle2 === void 0 ? void 0 : _device$promoBundle2.link) || '',
    icon: /*#__PURE__*/React.createElement(PercentOutlineIcon, {
      size: 20
    }),
    isNoUnderline: true,
    onClick: (_device$promoBundle3 = device.promoBundle) === null || _device$promoBundle3 === void 0 ? void 0 : _device$promoBundle3.onClick,
    size: "size5-r-s",
    variant: "dark"
  }, ((_device$promoBundle4 = device.promoBundle) === null || _device$promoBundle4 === void 0 ? void 0 : _device$promoBundle4.label) || '')), isPromoCode && /*#__PURE__*/React.createElement(PromoItem, null, /*#__PURE__*/React.createElement(Link, {
    href: ((_device$promoCode2 = device.promoCode) === null || _device$promoCode2 === void 0 ? void 0 : _device$promoCode2.link) || '',
    icon: /*#__PURE__*/React.createElement(GiftOutlineIcon, {
      fill: "#FFC800",
      size: 20
    }),
    isNoUnderline: true,
    onClick: (_device$promoCode3 = device.promoCode) === null || _device$promoCode3 === void 0 ? void 0 : _device$promoCode3.onClick,
    size: "size5-r-s",
    variant: "dark"
  }, ((_device$promoCode4 = device.promoCode) === null || _device$promoCode4 === void 0 ? void 0 : _device$promoCode4.label) || ''))) : null;
};